// extracted by mini-css-extract-plugin
export default {"list":"WitsmlList_list__xHSn2","icon":"WitsmlList_icon__cphMk","item":"WitsmlList_item__+g9fc","subtitle":"WitsmlList_subtitle__q3Lvc","bold":"WitsmlList_bold__8nQgE"};